import { ErrorFile } from './errorFile';

export class ErrorG2000File extends ErrorFile {
  unitsReferenceFileName: string;

  constructor(message: string, fileName: string, unitsReferenceFileName: string) {
    super(message, fileName);
    this.unitsReferenceFileName = unitsReferenceFileName;
  }
}
